import { EcoaContent } from "@components/common/EconContent";
import { sessionSlice } from "@maven-rest/states";
import { useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { Footer } from "@layouts/Footer";
import { useLangContext } from "@layouts/home/LangContext";
import { ecoaAccessCodeApi } from "maven-lib/dist/states/apis/ecoaAccessCode";
import { HbButton } from "@maven-surface/components/base/HbButton";
import { HbCodeInput } from "@maven-surface/components/base/HbCodeInput";
import { HbDivider } from "@maven-surface/components/base/HbDivider";
import { HbParagraph } from "@maven-surface/components/base/HbParagraph";
import { HbRequestButton } from "@maven-surface/components/base/HbRequestButton";
import { useRoute } from "@maven-surface/hooks/useRoute";
import { CDMS_STUDY_STATUS_CODE } from "@maven-msg/code/cdms/studyStatus";
import { ECOA_ACCESS_CODE_CODE } from "@maven-msg/code/ecoaAccessCode";
import { ECOA_ACCESS_CODE_LANG } from "@maven-msg/lang/ecoaAccessCode";
import { ECOA_CAPTURE_LANG } from "@maven-msg/lang/ecoaCapture";
import { MvnMessage } from "@maven-msg/lib/Message";

interface CodeVerificationProps {}

export function CodeVerification(props: CodeVerificationProps) {
  useLangContext();

  const { pushPath } = useRoute();
  const dispatch = useDispatch();
  const [accessCode, setAccessCode] = useState<string>("");

  const nextButtonRef = useRef<HTMLButtonElement>(null);
  const codeLength = 6;

  function handleCodeChange(code: string) {
    setAccessCode(code);
  }

  function handleCodeFilledUp() {
    const inputs = nextButtonRef?.current?.parentElement?.getElementsByTagName("button");
    if (!inputs?.length) return;
    inputs[0]?.focus();
  }

  return (
    <>
      <EcoaContent className="app-ecoa-page-home-code-verification" verticalAlign="CENTER">
        <HbParagraph align="CENTER" margin={2} color="GRAY" text={MvnMessage(ECOA_ACCESS_CODE_LANG.ECOA_VERIFY_TEXT_LABEL)} />
        <HbDivider space={1} />
        <HbParagraph bold={true} align="CENTER">
          {MvnMessage(ECOA_ACCESS_CODE_LANG.ECOA_VERIFY_PLACEHOLDER)}
        </HbParagraph>
        <HbCodeInput length={codeLength} code={accessCode} onValueChange={handleCodeChange} onInputCompleted={handleCodeFilledUp} />
        <HbDivider space={1} />
        <HbButton
          text={MvnMessage(ECOA_ACCESS_CODE_LANG.ECOA_INPUT_RESET_TEXT)}
          color="PRIMARY"
          disabled={!accessCode?.trim().length}
          onClick={() => setAccessCode("")}
        ></HbButton>
      </EcoaContent>
      <Footer>
        <HbRequestButton
          elementRef={nextButtonRef}
          text={MvnMessage(ECOA_CAPTURE_LANG.ECOA_CAPTURE_NEXT)}
          iconRight="ChromeBackMirrored"
          api={{
            ...ecoaAccessCodeApi.verifyEcoaAccessCode,
            data: () => ({
              accessCode,
            }),
          }}
          delegate={{
            success: (resp) =>
              resp.ecoaSpec?.twoFactorAuthType?.type === "SMS"
                ? pushPath(`/auth/sms?encryptedAccessCode=${encodeURIComponent(resp.encryptedAccessCode)}`)
                : pushPath(`/auth/birth?encryptedAccessCode=${encodeURIComponent(resp.encryptedAccessCode)}`),
            error: (error) => {
              if (error?.code === CDMS_STUDY_STATUS_CODE.STUDY_CLOSED.code) {
                dispatch(sessionSlice.actions.signOut());
              }

              return MvnMessage(ECOA_ACCESS_CODE_LANG.ECOA_VERIFY_FAIL, { message: error }, [
                ECOA_ACCESS_CODE_CODE.ECOA_ACCESS_CODE_NOT_FOUND,
                ECOA_ACCESS_CODE_CODE.ECOA_ACCESS_CODE_RATE_LIMIT,
              ]);
            },
          }}
        />
      </Footer>
    </>
  );
}
